import { Injectable, Inject } from '@angular/core';
import { StateTrackingService } from './state-tracking.service';
import { BodyClassService } from './body-class.service';

@Injectable({
  providedIn: 'root'
})
export class AppLifecycleService {

  constructor(
    @Inject(StateTrackingService) private stateTrackingService: StateTrackingService,
    @Inject(BodyClassService) private bodyClassService: BodyClassService
  ) {}

  /**
   * Called from AngularJS when a transition starts
   */
  public onTransitionStart(fromState: any): void {
    this.stateTrackingService.setPreviousState(fromState);
  }

  /**
   * Called from AngularJS when a transition succeeds
   */
  public onTransitionSuccess(toState: any): void {
    if (toState && toState.name) {
      this.bodyClassService.updateBodyClass(toState.name);
    }
  }

  /**
   * Get previous state (for Angular components that need it)
   */
  public getPreviousState(): any {
    return this.stateTrackingService.getPreviousState();
  }
}
